export const apiService = {
	api: '/api',
};

export type ApiService = typeof apiService;

export type FetchError = 'UnknownError' | 'ServerError';
